import { UK } from 'collections/countries';

export const DAP_INTERNATIONAL_AGGREGATOR = 'dapinternational';

export const DAP_OPERATORS_BY_COUNTRY: Record<string, readonly string[]> = {
  Germany: ['CS4 Logistics GmbH Air', 'CS4 Logistics GmbH Sea', 'VERAG', 'SABU-UK GmbH'],
  Austria: ['Hadolt Global Express Austria GmbH', 'Cargo-partner GmbH'],
  [UK]: ['GOT FREIGHT LTD', 'TRANS GLOBE SHIPPING LTD'],
  Netherlands: ['Rotra Air & Ocean BV', 'Schneider Expeditie BV'],
  Italy: ['Tecnofreight srl', 'Caterina Barberio SRL', 'Martino Parisi s.r.l.', 'G.T. TRASPORTI S.R.L'],
  Poland: ['JAS Worldwide'],
  Sweden: ['SCANDINAVIAN SHIPPING & LOGISTICS AB'],
  France: ['Transport Express Aeriel Mondial S.A.R.L', 'Militzer & Münch France S.A.', 'DIMOTRANS Group'],
  Spain: ['SPARBER AIR CARGO', 'ITS Independent Transport & Shipping AB'],
};

export const DAP_COUNTRY_OPERATOR_NAMES = new Set(Object.values(DAP_OPERATORS_BY_COUNTRY).flat());

interface FilterLogisticOperatorOptionsParams<T extends { value: string }> {
  aggregator?: string | null;
  destinationCountry?: string | null;
  options: T[];
}

export const filterLogisticOperatorOptions = <T extends { value: string }>({
  aggregator,
  destinationCountry,
  options,
}: FilterLogisticOperatorOptionsParams<T>): T[] => {
  if (aggregator === DAP_INTERNATIONAL_AGGREGATOR) {
    const allowedNames = new Set(DAP_OPERATORS_BY_COUNTRY[destinationCountry ?? ''] ?? []);

    return options.filter((option) => allowedNames.has(option.value));
  }

  return options.filter((option) => !DAP_COUNTRY_OPERATOR_NAMES.has(option.value));
};

interface IsOperatorAllowedForAggregatorParams {
  aggregator?: string | null;
  destinationCountry?: string | null;
  operator?: string | null;
}

export const isOperatorAllowedForAggregator = ({
  aggregator,
  destinationCountry,
  operator,
}: IsOperatorAllowedForAggregatorParams): boolean => {
  if (!operator) return true;

  if (aggregator !== DAP_INTERNATIONAL_AGGREGATOR) return true;

  const allowedNames = DAP_OPERATORS_BY_COUNTRY[destinationCountry ?? ''] ?? [];

  return allowedNames.includes(operator);
};
